import React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {GamePrize} from "types/entities/GamePrize";
import {CheckIcon, ExclamationTriangleIcon} from "@heroicons/react/24/outline";

interface OlmaGameResultParams {
    status?: "success";
}

interface OlmaGameResultLocationState {
    prizeDetail?: GamePrize | null;
}

type OlmaGameResultProps = RouteComponentProps<OlmaGameResultParams, any, OlmaGameResultLocationState>;

const OlmaGameResult = ({location, match}: OlmaGameResultProps) => {
    const {t} = useTranslation();
    const hasPrize = match.params.status === "success";
    const prizeDetail = location.state?.prizeDetail;
    const visitDate = new Date();
    const visitDateValue = `${visitDate.getFullYear()}-${String(visitDate.getMonth() + 1).padStart(2, "0")}-${String(visitDate.getDate()).padStart(2, "0")}`;
    const arboparkUrl = new URL("https://www.arbopark.ch");
    arboparkUrl.search = new URLSearchParams({
        utm_source: "olma",
        utm_medium: "gaming",
        utm_campaign: "olma_2026",
        utm_prize_id: String(prizeDetail?.prize_number ?? "unknown"),
        utm_result: hasPrize ? "success" : "failure",
        utm_visit_date: visitDateValue,
    }).toString();

    return (
        <main className="OlmaGameResult flex min-h-[60vh] items-center justify-center px-4 py-12 z-20 relative">
            <div className="w-full max-w-xl rounded-2xl bg-white p-6 text-center shadow-lg sm:p-10 flex flex-col space-y-4 items-center justify-center">
                <picture className="max-w-[230px]">
                    <img className="w-full h-full object-contain" src="/img/arboarena.svg" />
                </picture>
                <div
                    aria-hidden="true"
                    className={`flex h-14 w-14 items-center justify-center rounded-full sm:h-16 sm:w-16 ${
                        hasPrize ? "bg-green-600 text-green-300" : "bg-arbo-orange text-white"
                    }`}
                >
                    {hasPrize ? (
                        <CheckIcon className="h-7 w-7 sm:h-8 sm:w-8 lg:h-10 lg:w-10 " />
                    ) : (
                        <ExclamationTriangleIcon className="h-7 w-7 sm:h-8 sm:w-8 lg:h-10 lg:w-10" />
                    )}
                </div>
                <h1 className="text-3xl font-semibold font-zuume text-gray-900 sm:text-5xl">{hasPrize ? t("Success") : t("Try again next time")}</h1>
                {prizeDetail && (
                    <div className="prizeDetail rounded-xl flex flex-col bg-gray-200 p-6 w-full items-center">
                        <span className="text-arbo-red font-zuume font-black text-4xl sm:text-6xl">
                            {prizeDetail.article.article_name as unknown as string}
                        </span>
                        {prizeDetail.text && <span className="text-gray-800">{prizeDetail.text}</span>}
                    </div>
                )}
                <div className={"font-medium text-gray-700"}>
                    {hasPrize ? (
                        <span>Dein Gewinn ist unterwegs an deine E-Mail-Adresse. Schau auch im Spam-Ordner nach.</span>
                    ) : (
                        <span>
                            Mit dieser E-Mail-Adresse wurde in den letzten 24 Stunden bereits ein Gewinn eingelöst. Pro Adresse ist täglich nur eine Gewinneinlösung möglich.
                            <br />
                            <br />
                            Dein Gewinn bleibt gültig — probier es morgen nochmals.
                        </span>
                    )}
                </div>
                <div className={"text-arbo-green font-bold"}>
                    <a href={arboparkUrl.toString()}>arbopark.ch besuchen</a>
                </div>
            </div>
        </main>
    );
};

export default withRouter(OlmaGameResult);
